import axios from '../utils/axios';

export default function getRecruiterStatusLogs(adminId, params) {
    return axios.get(`/admin/${adminId}/recruiter-status-logs`, { params });
}